const React = require("react");
const {Page: PageWrapper, View, Text} = require("@react-pdf/renderer");

const styles = require("../../styles/");
const LogoWhite = require("./components/LogoWhite");

module.exports = ({children}) => (
  <PageWrapper style={styles.body}>
    <View style={styles.header} fixed>
      <LogoWhite width={49} height={9} />
      <Text>
        kyc
      </Text>
    </View>
    {children}
  </PageWrapper>
);
